<template>
    <div>
        <compWrapper
            :title="
                $t('boss.purchase.purchase_requisition', {
                    defaultValue: '采购申请',
                })
            "
            theme="primary"
        >
            <compFormQuery
                class="margin-top-15 margin-right-15"
                :formdata="getBase"
                :value="formData"
                :labelWidth="120"
            ></compFormQuery>
        </compWrapper>
        <compWrapper
            :title="
                $t('boss.purchase.transfer_purchase', {
                    defaultValue: '转采购单',
                })
            "
            theme="info"
        >
            <Alert class="margin-15 font-bold" type="error">{{
                $t("boss.purchase.requested_quantity", {
                    defaultValue:
                        "申请数量可分批转采购单；每批采购可选择不同供应商，请按实际情况填写",
                })
            }}</Alert>
            <vForm labelWidth="100" class="clearfix margin-15" ref="posupplier">
                <vCol span="24" style="margin-top: -10px">
                    <div class="font-weight" style="margin-left: 30px">
                        {{
                            $t("boss.purchase.basic_information", {
                                defaultValue: "基本信息",
                            })
                        }}
                    </div>
                    <div
                        style="
                            width: 99%;
                            margin-left: 15px;
                            margin-bottom: 15px;
                            font-weight: bold;
                            border-bottom: 1px solid #eae7e7;
                        "
                    ></div>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.supplier', {
                                defaultValue: '供应商',
                            })
                        "
                        :rules="required"
                        prop="supplierId"
                    >
                        <!-- <vSelect
                            v-model="formData.supplierId"
                            filterable
                            clearable
                            @on-change="
                                getPayment(formData.supplierId), getPrice()
                            "
                        > -->
                        <vSelect
                            v-model="formData.supplierId"
                            filterable
                            clearable
                        >
                            <vOption
                                v-for="(item, index) in getNewSupplier"
                                :value="item.value"
                                :key="index"
                                >{{ item.label }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.procurement_model', {
                                defaultValue: '采购模式',
                            })
                        "
                        :rules="required"
                        prop="paymentType"
                    >
                        <vSelect
                            v-model="formData.paymentType"
                            filterable
                            clearable
                            @on-change="changePayment"
                        >
                            <vOption
                                v-for="(item, index) in buyModeList"
                                :value="item.value"
                                :key="index"
                                >{{ item.label }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.purchase_currency', {
                                defaultValue: '采购币种',
                            })
                        "
                        :rules="required"
                        prop="currency"
                    >
                        <vSelect
                            v-model="formData.currency"
                            @on-change="getPrice"
                        >
                            <vOption
                                v-for="item in getAllCurrency"
                                :key="item.key"
                                :value="item.value"
                                >{{ item.label }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.inspect_goods', {
                                defaultValue: '是否需要验货',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{
                                formData.isNeedInspect == 0
                                    ? $t("boss.purchase.deny", {
                                          defaultValue: "否",
                                      })
                                    : $t("boss.purchase.correct", {
                                          defaultValue: "是",
                                      })
                            }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.inspect_goods', {
                                defaultValue: '是否需要验货',
                            })
                        "
                        v-else
                        :rules="required"
                        prop="paymentType"
                    >
                        <vRadio
                            trueValue="0"
                            :strict="false"
                            v-model="formData.isNeedInspect"
                            class="margin-right-10"
                            >{{
                                $t("boss.purchase.deny", {
                                    defaultValue: "否",
                                })
                            }}</vRadio
                        >
                        <vRadio
                            trueValue="1"
                            :strict="false"
                            v-model="formData.isNeedInspect"
                            >{{
                                $t("boss.purchase.correct", {
                                    defaultValue: "是",
                                })
                            }}</vRadio
                        >
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.purchaser', {
                                defaultValue: '采购员',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{
                                getBuyMode(formData.poUserId, "poUserId")
                                    .label || "--"
                            }}
                        </div>
                    </vFormItem>

                    <vFormItem
                        :label="
                            $t('boss.purchase.purchaser', {
                                defaultValue: '采购员',
                            })
                        "
                        v-else
                        :rules="required"
                        prop="paymentType"
                    >
                        <vSelect
                            v-model="formData.poUserId"
                            filterable
                            clearable
                        >
                            <vOption
                                v-for="(item, index) in getUserList"
                                :value="item.value"
                                :key="index"
                                >{{ item.label }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.batch_number', {
                                defaultValue: '批次号',
                            })
                        "
                        prop="refNo"
                    >
                        <vInput v-model="formData.refNo"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.source_no', {
                                defaultValue: '来源单号',
                            })
                        "
                        prop="inboundRefNo"
                    >
                        <vInput v-model="formData.inboundRefNo"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="24" style="margin-top: -10px">
                    <div class="font-weight" style="margin-left: 30px">
                        {{
                            $t("boss.purchase.contract_information", {
                                defaultValue: "合同信息",
                            })
                        }}
                    </div>
                    <div
                        style="
                            width: 99%;
                            margin-left: 15px;
                            margin-bottom: 15px;
                            font-weight: bold;
                            border-bottom: 1px solid #eae7e7;
                        "
                    ></div>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.promise_delivery', {
                                defaultValue: '承诺交货日期',
                            })
                        "
                        :rules="required"
                        prop="promiseDeliveryDate"
                    >
                        <vDatepicker
                            v-model="formData.promiseDeliveryDate"
                            format="yyyy-mm-dd"
                        ></vDatepicker>
                    </vFormItem>
                </vCol>
                <vCol span="12" v-if="type == 'query'">
                    <vFormItem
                        :label="
                            $t('boss.purchase.contract_signing', {
                                defaultValue: '合同签订日期',
                            })
                        "
                    >
                        <div class="font-weight">
                            {{ formData.contractSignDate || "--" }}
                        </div>
                    </vFormItem>
                </vCol>
                <vCol span="12" v-else>
                    <vFormItem
                        :label="
                            $t('boss.purchase.contract_signing', {
                                defaultValue: '合同签订日期',
                            })
                        "
                    >
                        <vDatepicker
                            v-model="formData.contractSignDate"
                            format="yyyy-mm-dd"
                        ></vDatepicker>
                    </vFormItem>
                </vCol>
                <vCol span="12" v-if="type == 'query'">
                    <vFormItem
                        :label="
                            $t('boss.purchase.buyer', {
                                defaultValue: '买方',
                            })
                        "
                    >
                        <!-- <div class="font-weight">{{getBuyTypeLabel(formData.buyerType)}}</div> -->
                        <div class="font-weight">{{ this.buyerLabel }}</div>
                    </vFormItem>
                </vCol>
                <vCol span="12" v-else>
                    <vFormItem
                        :label="
                            $t('boss.purchase.buyer', {
                                defaultValue: '买方',
                            })
                        "
                        :rules="
                            formData.paymentType === 'payment' ||
                            formData.paymentType === 'fk'
                                ? required
                                : []
                        "
                        prop="buyerType"
                    >
                        <vSelect
                            v-model="formData.buyerType"
                            filterable
                            clearable
                        >
                            <vOption
                                v-for="item in getBuyType"
                                :value="item.value"
                                :key="item.key"
                                >{{ item.label }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.payer', {
                                defaultValue: '付款方',
                            })
                        "
                        v-if="type == 'query'"
                    >
                        <div class="font-weight">
                            {{
                                getBuyMode(
                                    formData.poPurchaserId,
                                    "poPurchaserId"
                                ).purchaserName || "--"
                            }}
                        </div>
                    </vFormItem>
                    <vFormItem
                        :label="
                            $t('boss.purchase.payer', {
                                defaultValue: '付款方',
                            })
                        "
                        v-else
                        prop="poPurchaserId"
                        :rules="
                            formData.paymentType === 'payment' ||
                            formData.paymentType === 'fk'
                                ? required
                                : []
                        "
                    >
                        <vSelect
                            v-model="formData.poPurchaserId"
                            filterable
                            clearable
                        >
                            <vOption
                                v-for="(item, index) in purchaserList"
                                :value="item.id"
                                :key="index"
                                >{{ item.purchaserName }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>

                <vCol span="12">
                    <vFormItem label="Payment Term" v-if="type == 'query'">
                        <div class="font-weight">
                            <span v-if="!paymentItem.paymentName">--</span>
                            <a
                                v-else
                                @click="
                                    handlePaymentDetail(formData.paymentTermId)
                                "
                                >{{ paymentItem.paymentName }}</a
                            >
                        </div>
                    </vFormItem>
                    <vFormItem
                        label="Payment Term"
                        v-else
                        prop="paymentName"
                        :rules="
                            formData.paymentType == 'fk' ||
                            formData.paymentType == 'payment'
                                ? required
                                : {}
                        "
                    >
                        <vInput v-model="paymentItem.paymentName" readonly>
                            <Icon
                                style="
                                    cursor: pointer;
                                    font-size: 18px;
                                    margin-right: 5px;
                                "
                                slot="suffix"
                                type="md-search"
                                @click="this.handleChoosePayment"
                            ></Icon>
                        </vInput>
                    </vFormItem>
                </vCol>

                <!-- <vCol span="12">
                    <vFormItem
                        label="付款账期(天)"
                        prop="paymentDay"
                        :rules="
                            formData.paymentType === 'payment' ||
                            formData.paymentType === 'fk'
                                ? required
                                : []
                        "
                    >
                        <vInputNumber
                            v-model="formData.paymentDay"
                        ></vInputNumber>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        label="预付款比例(%)"
                        prop="paymentRate"
                        :rules="
                            formData.paymentType === 'payment' ||
                            formData.paymentType === 'fk'
                                ? required
                                : []
                        "
                    >
                        <vInputNumber
                            v-model="formData.paymentRate"
                            min="0"
                            max="100"
                        ></vInputNumber>
                    </vFormItem>
                </vCol> -->
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.payment_instructions', {
                                defaultValue: '付款说明',
                            })
                        "
                    >
                        <vInput
                            v-model="formData.paymentExplain"
                            prop="paymentExplain"
                            :rules="
                                formData.paymentType === 'payment' ||
                                formData.paymentType === 'fk'
                                    ? required
                                    : []
                            "
                        ></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <!-- <vFormItem
                        label="成本结算类型"
                        prop="costType"
                        :rules="
                            formData.paymentType === 'payment' ||
                            formData.paymentType === 'fk'
                                ? required
                                : []
                        "
                    > -->
                    <vFormItem
                        :label="
                            $t('boss.purchase.settlement_type', {
                                defaultValue: '成本结算类型',
                            })
                        "
                        prop="costType"
                        :rules="required"
                    >
                        <vSelect
                            v-model="formData.costType"
                            filterable
                            clearable
                        >
                            <vOption value="FOB">FOB</vOption>
                            <vOption value="DDP">DDP</vOption>
                            <vOption value="DDU">DDU</vOption>
                            <vOption value="CIF">CIF</vOption>
                            <vOption value="EXW">EXW</vOption>
                            <vOption value="FCA">FCA</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="24" style="margin-top: -10px">
                    <div class="font-weight" style="margin-left: 30px">
                        {{
                            $t("boss.purchase.other_information", {
                                defaultValue: "其他信息",
                            })
                        }}
                    </div>
                    <div
                        style="
                            width: 99%;
                            margin-left: 15px;
                            margin-bottom: 15px;
                            font-weight: bold;
                            border-bottom: 1px solid #eae7e7;
                        "
                    ></div>
                </vCol>

                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.delivery_port', {
                                defaultValue: '预计交货港口',
                            })
                        "
                        prop="expectedDeliveryPort"
                        :rules="
                            formData.paymentType === 'payment' ||
                            formData.paymentType === 'fk'
                                ? required
                                : []
                        "
                    >
                        <!-- <vInput v-model="formData.expectedDeliveryPort"></vInput> -->
                        <vSelect
                            :filterable="true"
                            :clearable="true"
                            v-model="formData.expectedDeliveryPort"
                        >
                            <vOption
                                v-for="item in portList"
                                :key="item.value"
                                :value="item.value"
                                >{{ item.label }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>

                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.warehouse', {
                                defaultValue: '预计接收仓库',
                            })
                        "
                        prop="expectedReceiveWarehouseId"
                        :rules="
                            formData.paymentType === 'payment' ||
                            formData.paymentType === 'fk'
                                ? required
                                : []
                        "
                    >
                        <vSelect
                            v-model="formData.expectedReceiveWarehouseId"
                            filterable
                            clearable
                            @on-change="
                                getNewWarehouseCode(
                                    formData.expectedReceiveWarehouseId
                                )
                            "
                        >
                            <vOption
                                v-for="item in getFBBFilterDisabledAllWarehouse"
                                :key="item.key"
                                :value="item.value"
                                >{{ item.label }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.expected_shelf_date', {
                                defaultValue: '预计上架日期',
                            })
                        "
                        prop="expectedFinishDate"
                        :rules="required"
                    >
                        <vDatepicker
                            v-model="formData.expectedFinishDate"
                            format="yyyy-mm-dd"
                        ></vDatepicker>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.theoretical_delivery_date', {
                                defaultValue: '理论交货日期',
                            })
                        "
                    >
                        <div class="font-bold">
                            {{ formData.theoryDeliveryDate || "--" }}
                        </div>
                    </vFormItem>
                </vCol>
                <vCol span="12" v-if="showaccount">
                    <vFormItem
                        :label="
                            $t('boss.purchase.ONITE_channel', {
                                defaultValue: 'ONSITE渠道',
                            })
                        "
                        :rules="required"
                        prop="channelFlag"
                    >
                        <vSelect
                            clearable
                            filterable
                            v-model="formData.channelFlag"
                        >
                            <vOption
                                v-for="(item, index) in channelList"
                                :key="index"
                                :value="item.accountFlag"
                                >{{ item.accountFlag }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>
            </vForm>
        </compWrapper>

        <compWrapper
            v-if="formData.paymentType === 'fk'"
            :title="
                $t('boss.purchase.risk_control', {
                    defaultValue: '金融风控信息',
                })
            "
            theme="warning"
        >
            <vForm
                :label-width="110"
                class="clearfix margin-15"
                :model="poOrderFk"
                ref="fkform"
            >
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.funding_party', {
                                defaultValue: '资金方',
                            })
                        "
                        prop="funderName"
                        :rules="required"
                    >
                        <vSelect
                            v-model="poOrderFk.funderId"
                            @on-change="getRate(poOrderFk.funderId)"
                        >
                            <vOption
                                v-for="(item, index) in funderList"
                                :key="index"
                                :value="item.id"
                                >{{ item.funderName }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.exchange_rate', {
                                defaultValue: '汇率',
                            })
                        "
                        prop="exchangeRate"
                        :rules="required"
                    >
                        <vInput v-model="poOrderFk.exchangeRate"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.contract_number', {
                                defaultValue: '合同编号',
                            })
                        "
                        prop="referenceNo"
                        :rules="required"
                    >
                        <vInput v-model="poOrderFk.referenceNo"></vInput>
                    </vFormItem>
                </vCol>

                <vCol span="24" style="margin-top: -10px">
                    <div class="font-weight" style="margin-left: 30px">
                        {{
                            $t("boss.purchase.purchase_contract_information", {
                                defaultValue: "采购合同信息",
                            })
                        }}
                    </div>
                    <div
                        style="
                            width: 99%;
                            margin-left: 15px;
                            margin-bottom: 15px;
                            font-weight: bold;
                            border-bottom: 1px solid #eae7e7;
                        "
                    ></div>
                </vCol>

                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.delivery_time', {
                                defaultValue: '提货时间',
                            })
                        "
                        prop="pickUpTime"
                        :rules="required"
                    >
                        <vDatepicker
                            type="date"
                            v-model="poOrderFk.pickUpTime"
                        ></vDatepicker>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.shortage_ratio', {
                                defaultValue: '溢短装比例(%)',
                            })
                        "
                        prop="exceedRatio"
                        :rules="required"
                    >
                        <vInput v-model="poOrderFk.exceedRatio"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.risk_fund', {
                                defaultValue: '风险金',
                            })
                        "
                    >
                        <vInput v-model="poOrderFk.advance"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.risk_fund_requirement', {
                                defaultValue: '风险金要求',
                            })
                        "
                    >
                        <vInput v-model="poOrderFk.advanceRequirement"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.procurement_contract', {
                                defaultValue: '采购合同结算方式',
                            })
                        "
                    >
                        <vSelect
                            clearable
                            v-model="poOrderFk.purchaseSettlementMethod"
                        >
                            <vOption :value="1">{{
                                $t("boss.purchase.money_transfer", {
                                    defaultValue: "汇款",
                                })
                            }}</vOption>
                            <vOption :value="2">{{
                                $t("boss.purchase.transfer_accounts", {
                                    defaultValue: "转账",
                                })
                            }}</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.settlement_days', {
                                defaultValue: '结算天数',
                            })
                        "
                    >
                        <vInput
                            v-model="poOrderFk.purchaseSettlementDays"
                        ></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.delivery_address', {
                                defaultValue: '提货地址',
                            })
                        "
                    >
                        <vInput v-model="poOrderFk.pickUpAddress"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.delivery_method', {
                                defaultValue: '提货方式',
                            })
                        "
                    >
                        <vInput v-model="poOrderFk.pickUpMethod"></vInput>
                    </vFormItem>
                </vCol>

                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.consignee', {
                                defaultValue: '提货人',
                            })
                        "
                    >
                        <vInput v-model="poOrderFk.consignee"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.consignee_phone', {
                                defaultValue: '提货人联系电话',
                            })
                        "
                    >
                        <vInput v-model="poOrderFk.phone"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.delivery_requirements', {
                                defaultValue: '提货要求',
                            })
                        "
                    >
                        <vInput v-model="poOrderFk.pickUpRequirement"></vInput>
                    </vFormItem>
                </vCol>

                <vCol span="24" style="margin-top: -10px">
                    <div class="font-weight" style="margin-left: 30px">
                        {{
                            $t("boss.purchase.export_contract_Information", {
                                defaultValue: "外销合同信息",
                            })
                        }}
                    </div>
                    <div
                        style="
                            width: 99%;
                            margin-left: 15px;
                            margin-bottom: 15px;
                            font-weight: bold;
                            border-bottom: 1px solid #eae7e7;
                        "
                    ></div>
                </vCol>

                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.latest_delivery_date', {
                                defaultValue: '最迟交货日期',
                            })
                        "
                        prop="latestDeliveryTime"
                        :rules="required"
                    >
                        <vDatepicker
                            type="date"
                            v-model="poOrderFk.latestDeliveryTime"
                        ></vDatepicker>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.settlement_method', {
                                defaultValue: '外销合同结算方式',
                            })
                        "
                    >
                        <vSelect
                            clearable
                            v-model="poOrderFk.exportSettlementMethod"
                        >
                            <vOption :value="1">{{
                                $t("boss.purchase.money_transfer", {
                                    defaultValue: "汇款",
                                })
                            }}</vOption>
                            <vOption :value="2">{{
                                $t("boss.purchase.transfer_accounts", {
                                    defaultValue: "转账",
                                })
                            }}</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.settlement_export_contracts', {
                                defaultValue: '外销合同结算天数',
                            })
                        "
                    >
                        <vInput
                            v-model="poOrderFk.exportSettlementDays"
                        ></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.currency_settlement', {
                                defaultValue: '外销合同结算币种',
                            })
                        "
                    >
                        <vSelect
                            clearable
                            v-model="poOrderFk.exportSettlementCurrency"
                        >
                            <vOption value="USD">USD</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.trade_term', {
                                defaultValue: '贸易术语',
                            })
                        "
                        prop="tradeTerm"
                        :rules="required"
                    >
                        <vInput v-model="poOrderFk.tradeTerm"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.delivery_location', {
                                defaultValue: '交货地点',
                            })
                        "
                    >
                        <vInput
                            v-model="poOrderFk.deliveryAddress"
                            :placeholder="
                                $t('boss.purchase.freight_forwarder', {
                                    defaultValue: '货代提货点',
                                })
                            "
                        ></vInput>
                    </vFormItem>
                </vCol>

                <vCol span="24" style="margin-top: -10px">
                    <div class="font-weight" style="margin-left: 30px">
                        {{
                            $t("boss.purchase.other_information", {
                                defaultValue: "其它信息",
                            })
                        }}
                    </div>
                    <div
                        style="
                            width: 99%;
                            margin-left: 15px;
                            margin-bottom: 15px;
                            font-weight: bold;
                            border-bottom: 1px solid #eae7e7;
                        "
                    ></div>
                </vCol>

                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.domestic_transportation', {
                                defaultValue: '国内运输',
                            })
                        "
                    >
                        <vSelect
                            clearable
                            v-model="poOrderFk.domesticTransport"
                        >
                            <vOption :value="1">{{
                                $t("boss.purchase.domestic_transportation", {
                                    defaultValue: "国内运输",
                                })
                            }}</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.initial_transportation', {
                                defaultValue: '头程运输',
                            })
                        "
                    >
                        <vSelect
                            clearable
                            v-model="poOrderFk.firstWayTransport"
                        >
                            <vOption
                                v-for="item in transoprtList"
                                :key="item.key"
                                :value="item.value"
                                >{{ item.label }}</vOption
                            >
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.storage_services', {
                                defaultValue: '仓储服务',
                            })
                        "
                    >
                        <vSelect clearable v-model="poOrderFk.warehouseService">
                            <vOption :value="0">{{
                                $t("boss.purchase.not_enabled", {
                                    defaultValue: "不启用",
                                })
                            }}</vOption>
                            <vOption :value="1">{{
                                $t("boss.purchase.enabled", {
                                    defaultValue: "启用",
                                })
                            }}</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="8">
                    <vFormItem
                        :label="
                            $t('boss.purchase.delivery_service', {
                                defaultValue: '配送服务',
                            })
                        "
                    >
                        <vSelect clearable v-model="poOrderFk.deliveryService">
                            <vOption :value="0">{{
                                $t("boss.purchase.not_enabled", {
                                    defaultValue: "不启用",
                                })
                            }}</vOption>
                            <vOption :value="1">{{
                                $t("boss.purchase.enabled", {
                                    defaultValue: "启用",
                                })
                            }}</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>

                <vCol span="24">
                    <vFormItem
                        v-if="type !== 'query'"
                        :label="
                            $t('boss.purchase.purchase_contract', {
                                defaultValue: '采购合同',
                            })
                        "
                        prop="purchaseContractMeta"
                        :rules="required"
                    >
                        <!-- <vInput v-model="poOrderFk.purchaseContractMeta"></vInput> -->
                        <Button
                            type="success"
                            v-if="purchaseList.length == 0"
                            @click="purchaseUpload"
                            >{{
                                $t("boss.purchase.upload", {
                                    defaultValue: "上传",
                                })
                            }}</Button
                        >
                    </vFormItem>
                    <Table
                        class="margin-25"
                        :columns="purchaseColumns"
                        :data="purchaseList"
                        size="small"
                        ref="table1"
                        border
                    ></Table>
                </vCol>
                <vCol span="24">
                    <vFormItem
                        v-if="type !== 'query'"
                        :label="
                            $t('boss.purchase.export_contract', {
                                defaultValue: '外销合同',
                            })
                        "
                        prop="exportContractMeta"
                        :rules="required"
                    >
                        <!-- <vInput v-model="poOrderFk.exportContractMeta"></vInput> -->
                        <Button
                            type="success"
                            v-if="exportList.length == 0"
                            @click="exportUpload"
                            >{{
                                $t("boss.purchase.upload", {
                                    defaultValue: "上传",
                                })
                            }}</Button
                        >
                    </vFormItem>
                    <Table
                        class="margin-25"
                        :columns="exportColumns"
                        :data="exportList"
                        size="small"
                        ref="table2"
                        border
                    ></Table>
                </vCol>
            </vForm>
        </compWrapper>

        <div class="margin-left-5">
            <vButton
                class="margin-left-10"
                theme="success"
                @click="importExcel"
                >{{
                    $t("boss.purchase.info", {
                        defaultValue: "导入",
                    })
                }}</vButton
            >
            <vButton
                class="margin-left-10"
                theme="warning"
                @click="exportExcel"
                >{{
                    $t("boss.purchase.export", {
                        defaultValue: "导出",
                    })
                }}</vButton
            >
        </div>
        <vTable
            class="margin-15"
            :columns="columns"
            :data="datalist"
            size="small"
            ref="tabledoc"
            border
        ></vTable>

        <div class="text-right">
            <vButton theme="primary" @click="submit">{{
                $t("boss.purchase.create_purchase_orders", {
                    defaultValue: "自动创建采购单",
                })
            }}</vButton>
            <vButton class="margin-left-10 margin-right-15" @click="cancel">{{
                $t("boss.purchase.cancel", {
                    defaultValue: "取消",
                })
            }}</vButton>
        </div>
        <vModal
            class="hidefooter customerupload"
            v-model="operate.show"
            :title="operate.title"
            v-bind="operate"
        >
            <compUpload
                v-bind="getFileProps"
                :data="operate.data"
                @on-success="aaasuccess"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>

        <vModal
            v-model="upload.show"
            :title="upload.title"
            v-bind="upload"
            :showFooter="false"
        >
            <compMutiUpload
                v-bind="mutiFileProps"
                @on-success="uploadSuccess"
                @on-cancel="cancelMutiUpload"
            ></compMutiUpload>
        </vModal>
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-confirm="modalProps.show = false"
            @on-close="closemodalprops"
        >
            <component
                :is="modalProps.component"
                v-bind="modalProps"
                @on-close="closemodalprops"
                v-on="modalProps.on"
            />
        </compModal>

        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
    HttpGetApplicateOne,
    HttpSavePoPurchase,
    HttpGetPrice,
    HttpFindByOrgIdAndOrgWarehouseId,
    HttpGetPurchaserList,
    HttpFindProvidersByOrg,
    HttpGetSystemPortList,
    HttpGetLastDeliveryDate,
    HttpGetExpectedDate,
    HttpGetPaymentDetail,
} from "@/service/purchase/purchase";
import mixin from "../../mixin";
import compPaymentTermList from "../../paymenttermlist.vue";
import compPaymentTermDetail from "../../paymenttermdetail.vue";

export default {
    props: ["activeid"],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compUpload: () => import("@components/templates/upload"),
        compMutiUpload: () => import("@components/templates/mutiUpload"),
        compPaymentTermList,
        compPaymentTermDetail,
    },
    mixins: [mixin],
    data() {
        return {
            type: "edit",
            formData: {
                paymentType: "undefined",
                paymentRate: "",
                paymentDay: "",
                currency: "USD",
                poUserId: this.$store.state.userinfo.id,
            },
            datalist: [],
            buyModeList: [
                {
                    value: "payment",
                    label: this.$t("boss.purchase.self_procurement", {
                        defaultValue: "自采",
                    }),
                },
                {
                    value: "unpayment",
                    label: this.$t("boss.purchase.agency_operations", {
                        defaultValue: "代运营",
                    }),
                },
                {
                    value: "fk",
                    label: this.$t(
                        "boss.purchase.financial_procurement_agency",
                        {
                            defaultValue: "金融代采",
                        }
                    ),
                },
                {
                    value: "undefined",
                    label: this.$t("boss.purchase.other", {
                        defaultValue: "其他",
                    }),
                },
            ],

            poOrderFk: {
                exceedRatio: "5",
                exportSettlementCurrency: "USD",
            },
            required: [
                {
                    required: true,
                    message: this.$t("boss.purchase.fill_in", {
                        defaultValue: "该信息不能为空,请填写",
                    }),
                },
            ],
            paymentItem: {
                id: "",
                paymentName: "",
            },
            operate: {
                id: null,
                title: "",
                show: false,
                actionurl: "",
                boxtype: "",
                downexcel: "",
                component: null,
                data: "",
            },
            modalProps: {
                show: false,
            },
            hasImport: false,
            loading: false,
            showaccount: false,
            rateDisabled: false,
            channelList: [],
            purchaserList: [],
            funderList: [],
            purchaseList: [],
            exportList: [],
            upload: {
                show: false,
            },
            portList: [],
            // hasRequest: false,
            isLock: true,
        };
    },
    watch: {
        "formData.expectedDeliveryPort": {
            immediate: true,
            handler(val) {
                if (!val)
                    return this.$set(this.formData, "theoryDeliveryDate", null);
                this.handleLastDeliveryDate();
            },
        },
        "formData.expectedReceiveWarehouseCode": {
            immediate: true,
            handler(val) {
                if (!val || val === "Other")
                    return this.$set(this.formData, "theoryDeliveryDate", null);
                this.handleLastDeliveryDate();
            },
        },
        datalist: {
            immediate: true,
            handler(val) {
                console.log(123456);
                if (!val || !val.length) {
                    this.$set(this.formData, "theoryDeliveryDate", null);
                    this.$set(this.formData, "expectedFinishDate", null);
                    return;
                }
                this.handleLastDeliveryDate();
                this.handleExpectNeedDate();
            },
        },
        "formData.supplierId": {
            immediate: true,
            handler(supplierId) {
                // if (this.isLock) return;
                if (!supplierId) return;
                this.getPaymentTermById();
            },
        },
    },
    created() {
        this.getPortList();
        this.update();
    },
    computed: {
        ...mapGetters("diction", [
            "getNewProductList",
            "getAllSupplier",
            "getAllCurrency",
        ]),
        ...mapGetters("dictionary", [
            "getWarehouseAllList",
            "getFBBFilterDisabledAllWarehouse",
            "getAllProductPerson",
        ]),
        getNewSupplier() {
            return this.getAllSupplier.filter((item) => {
                return item.attach.status === "NORMAL";
            });
        },
        getUserList() {
            return this.getAllProductPerson.filter(function (item) {
                // console.log(item)
                return item.label != "";
            });
        },
        transoprtList() {
            return [
                {
                    value: 1,
                    label: this.$t("boss.purchase.international_shipping", {
                        defaultValue: "国际海运",
                    }),
                },
                {
                    value: 2,
                    label: this.$t(
                        "boss.purchase.international_air_transport",
                        {
                            defaultValue: "国际空运",
                        }
                    ),
                },
                {
                    value: 3,
                    label: this.$t(
                        "boss.purchase.international_land_transportation",
                        {
                            defaultValue: "国际陆运",
                        }
                    ),
                },
            ];
        },
        getBase() {
            return [
                {
                    label: this.$t(
                        "boss.purchase.purchase_requisition_number",
                        {
                            defaultValue: "采购申请单号",
                        }
                    ),
                    key: "orderNo",
                    tag: "vInput",
                },
                {
                    label: this.$t("boss.purchase.document_status", {
                        defaultValue: "单据状态",
                    }),
                    key: "orderStatus",
                    tag: "vSelect",
                    options: [
                        {
                            value: "draft",
                            label: this.$t("boss.purchase.draft", {
                                defaultValue: "草稿",
                            }),
                        },
                        {
                            value: "submited",
                            label: this.$t("boss.purchase.submitted", {
                                defaultValue: "已提交",
                            }),
                        },
                        {
                            value: "approved",
                            label: this.$t("boss.purchase.audited", {
                                defaultValue: "已审核",
                            }),
                        },
                        {
                            value: "refused",
                            label: this.$t("boss.purchase.rejected", {
                                defaultValue: "已驳回",
                            }),
                        },
                        {
                            value: "canceled",
                            label: this.$t("boss.purchase.cancelled", {
                                defaultValue: "已取消",
                            }),
                        },
                        {
                            value: "closed",
                            label: this.$t("boss.purchase.closed", {
                                defaultValue: "已关闭",
                            }),
                        },
                    ],
                },
                {
                    label: this.$t("boss.purchase.project", {
                        defaultValue: "项目",
                    }),
                    key: "lineId",
                    tag: "vSelect",
                    options: this.getNewProductList,
                },
                {
                    label: this.$t("boss.purchase.warehouse", {
                        defaultValue: "预计接收仓库",
                    }),
                    key: "formExpectedReceiveWarehouseCode",
                    tag: "vSelect",
                    options: this.getFBBFilterDisabledAllWarehouse,
                },
                {
                    label: this.$t("boss.purchase.supplier", {
                        defaultValue: "供应商",
                    }),
                    key: "formSupplierName",
                    tag: "vSelect",
                    options: this.getAllSupplier,
                },
                {
                    label: this.$t("boss.purchase.purchase_currency", {
                        defaultValue: "采购币种",
                    }),
                    key: "currency",
                    tag: "vInput",
                },
                {
                    label: this.$t("boss.purchase.source_no", {
                        defaultValue: "来源单号",
                    }),
                    key: "queryRefNo",
                    tag: "vInput",
                },
                {
                    label: this.$t("boss.purchase.expected_shelf_date", {
                        defaultValue: "预计上架日期",
                    }),
                    key: "expectedNeedDate",
                    tag: "vInput",
                },
                {
                    label: this.$t("boss.purchase.notes", {
                        defaultValue: "备注",
                    }),
                    key: "remark",
                    tag: "vInput",
                },
            ];
        },
        mutiFileProps() {
            return {
                data: {
                    srcLabel: 0,
                    model: this.upload.model,
                    type: "other",
                },
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                multiple: false,
            };
        },
        getFileProps() {
            if (this.operate.downexcel) {
                return {
                    data: {
                        id: this.formData.id,
                    },
                    action:
                        process.env.VUE_APP_APIURL_BOSS +
                        this.operate.actionurl,
                    name: "excelFile",
                    download: () => {
                        this.handleWebfs(
                            process.env.VUE_APP_APIURL_BOSS +
                                this.operate.downexcel,
                            {},
                            "download"
                        );
                    },
                };
            } else {
                return {
                    data: {
                        id: this.formData.id,
                    },
                    action:
                        process.env.VUE_APP_APIURL_BOSS +
                        this.operate.actionurl,
                    name: "excelFile",
                };
            }
        },
        purchaseColumns() {
            let that = this;
            let result = [
                {
                    title: this.$t("boss.purchase.purchase_contract_name", {
                        defaultValue: "采购合同名称",
                    }),
                    key: "attachTitle",
                },
                {
                    title: this.$t("boss.purchase.contract_link", {
                        defaultValue: "合同链接",
                    }),
                    key: "attachUrl",
                },
                {
                    title: this.$t("boss.purchase.operate", {
                        defaultValue: "操作",
                    }),
                    render(h, { row, index }) {
                        let button = h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "primary",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            that.downloadAttach(0, index);
                                        },
                                    },
                                },
                                this.$t("boss.purchase.download", {
                                    defaultValue: "下载",
                                })
                            ),
                        ]);
                        if (that.type !== "query") {
                            button = h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small",
                                        },
                                        on: {
                                            click: () => {
                                                that.downloadAttach(0, index);
                                            },
                                        },
                                        style: {
                                            "margin-right": "10px",
                                        },
                                    },
                                    this.$t("boss.purchase.download", {
                                        defaultValue: "下载",
                                    })
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small",
                                        },
                                        on: {
                                            click: () => {
                                                that.removePurchase(index);
                                            },
                                        },
                                    },
                                    this.$t("boss.purchase.delete", {
                                        defaultValue: "删除",
                                    })
                                ),
                            ]);
                        }
                        return h("div", [button]);
                    },
                },
            ];
            return result;
        },
        exportColumns() {
            let that = this;
            let result = [
                {
                    title: this.$t("boss.purchase.export_contract_name", {
                        defaultValue: "外销合同名称",
                    }),
                    key: "attachTitle",
                },
                {
                    title: this.$t("boss.purchase.contract_link", {
                        defaultValue: "合同链接",
                    }),
                    key: "attachUrl",
                },
                {
                    title: this.$t("boss.purchase.operate", {
                        defaultValue: "操作",
                    }),
                    render(h, { row, index }) {
                        let button = h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "primary",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            that.downloadAttach(1, index);
                                        },
                                    },
                                },
                                this.$t("boss.purchase.download", {
                                    defaultValue: "下载",
                                })
                            ),
                        ]);
                        if (that.type !== "query") {
                            button = h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small",
                                        },
                                        on: {
                                            click: () => {
                                                that.downloadAttach(1, index);
                                            },
                                        },
                                        style: {
                                            "margin-right": "10px",
                                        },
                                    },
                                    this.$t("boss.purchase.download", {
                                        defaultValue: "下载",
                                    })
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small",
                                        },
                                        on: {
                                            click: () => {
                                                that.removeExport(index);
                                            },
                                        },
                                    },
                                    this.$t("boss.purchase.delete", {
                                        defaultValue: "删除",
                                    })
                                ),
                            ]);
                        }
                        return button;
                    },
                },
            ];
            return result;
        },
        columns() {
            return [
                {
                    title: "ERPSKU",
                    render(h, { row }) {
                        return <div>{row.erpsku}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.original_application", {
                        defaultValue: "原申请数量",
                    }),
                    render(h, { row }) {
                        return <div>{row.quantity}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.actual_applications", {
                        defaultValue: "实际申请数量",
                    }),
                    render(h, { row }) {
                        return (
                            <div>
                                {Number(row.quantity - row.cancelQuantity)}
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("boss.purchase.available_quantity", {
                        defaultValue: "可用数量",
                    }),
                    render(h, { row }) {
                        return <div>{row.valueQuantity}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.reference_price", {
                        defaultValue: "参考单价",
                    }),
                    render(h, { row }) {
                        return <div>{row.price}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.expected_shelf_date", {
                        defaultValue: "预计上架日期",
                    }),
                    render(h, { row }) {
                        return <div>{row.expectedNeedDate}</div>;
                    },
                },
                {
                    renderHeader: (h, params) => {
                        return h("div", [
                            h("Icon", {
                                props: {
                                    type: "ios-medical",
                                    color: "#ed3f14",
                                },
                            }),
                            h(
                                "strong",
                                this.$t("boss.purchase.purchase_unit_price", {
                                    defaultValue: "采购单价",
                                })
                            ),
                        ]);
                    },
                    render: (h, { row, index }) => {
                        return h("Input", {
                            props: {
                                size: "small",
                                value: row.supplierProductPrice,
                            },
                            on: {
                                input: (event) => {
                                    row.supplierProductPrice = event;
                                    this.datalist[index] = row;
                                },
                            },
                        });
                    },
                },
                {
                    renderHeader: (h, params) => {
                        return h("div", [
                            h("Icon", {
                                props: {
                                    type: "ios-medical",
                                    color: "#ed3f14",
                                },
                            }),
                            h(
                                "strong",
                                this.$t(
                                    "boss.purchase.transfer_purchase_quantity",
                                    {
                                        defaultValue: "转采购数量",
                                    }
                                )
                            ),
                        ]);
                    },
                    render: (h, { row, index }) => {
                        return h("Input", {
                            props: {
                                size: "small",
                                value: row.buyquantity,
                            },
                            on: {
                                input: (event) => {
                                    row.buyquantity = event;
                                    this.datalist[index] = row;
                                    this.handleExpectNeedDate();
                                    this.handleLastDeliveryDate();
                                },
                            },
                        });
                    },
                },
                {
                    title: this.$t("boss.purchase.notes", {
                        defaultValue: "备注",
                    }),
                    render: (h, { row, index }) => {
                        return h("Input", {
                            props: {
                                size: "small",
                                value: row.remark,
                            },
                            on: {
                                input: (event) => {
                                    row.remark = event;
                                    this.datalist[index] = row;
                                },
                            },
                        });
                    },
                },
            ];
        },
    },
    methods: {
        getPaymentTermById() {
            console.log(this.getAllSupplier);
            let supplierItem = this.getAllSupplier.filter((item) => {
                return this.formData.supplierId == item.value;
            })[0];
            if (
                !supplierItem ||
                !supplierItem.attach ||
                !supplierItem.attach.paymentTermId
            )
                return;
            HttpGetPaymentDetail({
                id: supplierItem.attach.paymentTermId,
            }).then(
                (res) => {
                    this.paymentItem.id = res.data.id;
                    this.paymentItem.paymentName = res.data.paymentName;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        handlePaymentDetail() {
            this.modalProps = {
                show: true,
                width: 1200,
                title: "Payment Term",
                component: "compPaymentTermDetail",
                params: this.formData.paymentTermId,
                querytype: "query",
                showFooter: false,
            };
        },
        handleChoosePayment() {
            this.modalProps = {
                show: true,
                width: 900,
                title: this.$t("boss.purchase.select_Payment_Term", {
                    defaultValue: "选择Payment Term",
                }),
                component: "compPaymentTermList",
                showFooter: false,
                on: {
                    "on-close": () => {
                        console.log("on-close");
                        this.modalProps.show = false;
                    },
                    "on-confirm": (data) => {
                        console.log("data", data);
                        this.paymentItem = data;
                        this.modalProps.show = false;
                    },
                },
            };
        },
        async handleExpectNeedDate() {
            // if (this.hasRequest) return;
            // 申请单表id数组
            let idList = this.datalist
                .filter((item) => {
                    console.log(item);
                    return item.buyquantity != 0;
                })
                .map((item) => {
                    return item.id;
                });
            console.log({
                prItemIds: idList,
            });
            if (!idList.length)
                return this.$set(this.formData, "expectedFinishDate", null);
            await HttpGetExpectedDate({
                // port: portName,
                // warehouseCode: warehouseCode,
                prItemIds: idList,
            }).then(
                (res) => {
                    if (!res.message)
                        return this.$set(
                            this.formData,
                            "expectedFinishDate",
                            null
                        );
                    this.$set(this.formData, "expectedFinishDate", res.message);
                },
                (err) => {
                    console.log(err);
                    this.$VMessage.error(err.message);
                }
            );
            // this.hasRequest = true;
        },
        async handleLastDeliveryDate() {
            // 港口
            let portName = this.formData.expectedDeliveryPort;
            // 仓库Code
            let warehouseCode = this.formData.expectedReceiveWarehouseCode;
            // 申请单表id数组
            let idList = this.datalist
                .filter((item) => {
                    console.log(item);
                    return item.buyquantity != 0;
                })
                .map((item) => {
                    return item.id;
                });
            console.log({
                port: portName,
                warehouseCode: warehouseCode,
                prItemIds: idList,
            });
            if (
                !portName ||
                !warehouseCode ||
                warehouseCode === "Other" ||
                !idList.length
            )
                return this.$set(this.formData, "theoryDeliveryDate", null);
            await HttpGetLastDeliveryDate({
                port: portName,
                warehouseCode: warehouseCode,
                prItemIds: idList,
                expectedFinishDate: this.formData.expectedFinishDate,
            }).then(
                (res) => {
                    console.log("res", res);
                    if (!res.message)
                        return this.$set(
                            this.formData,
                            "theoryDeliveryDate",
                            null
                        );
                    this.$set(this.formData, "theoryDeliveryDate", res.message);
                    // this.formData.theoryDeliveryDate = res.message;
                },
                (err) => {
                    console.log(err);
                    this.$VMessage.error(err.message);
                }
            );
        },
        async getPortList() {
            await HttpGetSystemPortList({
                page: 1,
                rows: 1000,
            }).then(
                (res) => {
                    this.portList = res.data.content.map((item) => {
                        return {
                            value: item.title,
                            label: item.title,
                            attach: {
                                ...item,
                            },
                        };
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        changePayment() {
            this.formData.paymentType == "fk"
                ? (this.formData.currency = "CNY")
                : "";
            if (
                this.formData.paymentType == "fk" ||
                this.formData.paymentType == "payment"
            ) {
                this.$set(this.formData, "isNeedInspect", 1);
            } else this.$set(this.formData, "isNeedInspect", 0);
            if (
                (this.formData.paymentType == "fk" ||
                    this.formData.paymentType == "payment") &&
                global.SYSID == 1
            ) {
                this.$set(this.formData, "poPurchaserId", 1);
            } else this.$set(this.formData, "poPurchaserId", null);
        },
        getRate(funderId) {
            let rateItem = this.funderList.filter((item) => {
                return funderId === item.id;
            })[0];
            if (rateItem) {
                this.poOrderFk.exchangeRate = rateItem.rate;
                this.rateDisabled = true;
            } else {
                this.poOrderFk.rate = "";
            }
        },
        getFunderName(value) {
            let funder = this.funderList.filter((item) => {
                return value === item.id;
            })[0];
            if (funder) return funder.funderName;
            return "--";
        },
        downloadAttach(type, index) {
            let fileUrl = "";
            switch (type) {
                // 采购合同
                case 0:
                    fileUrl = this.purchaseList[index].attachUrl;
                    break;
                // 外销合同
                case 1:
                    fileUrl = this.exportList[index].attachUrl;
                    break;
            }
            this.handleWebfs(fileUrl, {}, "download");
        },
        async removePurchase(index) {
            await this.delAttach(this.purchaseList[index].attachId, "purchase");
            this.purchaseList.splice(index, 1);
        },
        async removeExport(index) {
            await this.delAttach(this.exportList[index].attachId, "export");
            this.exportList.splice(index, 1);
        },
        purchaseUpload() {
            this.upload = {
                show: true,
                title: this.$t("boss.purchase.purchase_contract_upload", {
                    defaultValue: "采购合同上传",
                }),
                model: "po_order_fk_purchase",
            };
        },
        exportUpload() {
            this.upload = {
                show: true,
                title: this.$t("boss.purchase.upload_export_contract", {
                    defaultValue: "外销合同上传",
                }),
                model: "po_order_fk_export",
            };
        },

        uploadSuccess(res) {
            let list = [];
            // 采购合同
            if (this.upload.model === "po_order_fk_purchase") {
                list = this.purchaseList;
            }
            // 外销合同
            else {
                list = this.exportList;
            }
            res.items.map((item) => {
                list.push(item);
            });
            this.cancelMutiUpload();
        },
        cancelMutiUpload() {
            this.upload.show = false;
        },
        async update() {
            await HttpFindProvidersByOrg().then(
                (res) => {
                    // console.log(res,'23423423');
                    this.funderList = res.data || [];
                },
                (err) => {
                    this.funderList = [];
                }
            );
            await HttpGetPurchaserList().then(
                (res) => {
                    this.purchaserList = res.data;
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
            await HttpGetApplicateOne({
                id: this.activeid,
            }).then(
                (res) => {
                    this.formData = {
                        ...this.formData,
                        ...res.data,
                        formSupplierName: this.getSupplierName(
                            res.data.supplierId
                        ),
                        formExpectedReceiveWarehouseCode: res.data
                            .expectedReceiveWarehouseCode
                            ? res.data.expectedReceiveWarehouseCode
                            : "Other",
                        queryRefNo: res.data.refNo,
                        inboundRefNo: res.data.refNo,
                        refNo: "",
                    };
                    this.getBuyTypeLabel(this.formData.buyerType);
                    this.formData.contractSignDate = this.getDay(0);
                    this.datalist = res.data.poRequisitionItem;
                    let date = this.datalist[0].expectedNeedDate;

                    this.formData.poUserId = this.$store.state.userinfo.id;
                    this.datalist = this.datalist.map((item) => {
                        if (this.datalist.length > 1) {
                            let oldDate = new Date(date).getTime();
                            let ratherDate = new Date(
                                item.expectedNeedDate
                            ).getTime();
                            if (ratherDate > oldDate) {
                                date = item.expectedNeedDate;
                            }
                        }
                        item.buyquantity =
                            Number(item.quantity) -
                            Number(item.usedQuantity) -
                            Number(item.cancelQuantity);
                        if (item.buyquantity < 0) {
                            item.buyquantity = 0;
                        }
                        return {
                            ...item,
                            orderId: this.formData.id,
                            valueQuantity: item.buyquantity,
                        };
                    });
                    // this.formData.promiseDeliveryDate = date;
                    this.formData.paymentRate =
                        res.data.paymentRate === null
                            ? ""
                            : res.data.paymentRate;
                    this.formData.paymentDay =
                        res.data.paymentDay === null ? "" : res.data.paymentDay;

                    // 展示渠道选择
                    if (this.formData.expectedReceiveWarehouseCode != "") {
                        let channelone =
                            this.getFBBFilterDisabledAllWarehouse.filter(
                                (json) => {
                                    return (
                                        json.attach.code ==
                                        this.formData
                                            .expectedReceiveWarehouseCode
                                    );
                                }
                            )[0] || {};
                        console.log(channelone);
                        if (channelone.attach.warehouseType == 4) {
                            this.showaccount = true;
                            this.getChannel(
                                this.formData.expectedReceiveWarehouseCode
                            );
                        } else this.showaccount = false;
                    }

                    this.getPaymentType();
                    this.getPayment(this.formData.supplierId);
                    this.getPrice();
                },
                (err) => {
                    this.errorMessage(err.message);
                }
            );
            this.isLock = false;
        },
        getSupplierName(id) {
            if (id === 0) {
                return;
            }
            let name = "";
            this.getAllSupplier.map((item) => {
                if (item.value === id) {
                    name = item.label;
                }
            });
            return name;
        },
        getNewWarehouseCode(id) {
            this.getFBBFilterDisabledAllWarehouse.map((item) => {
                if (id === item.value) {
                    this.formData.expectedReceiveWarehouseCode =
                        item.attach.code;
                }
            });
            this.getChannel(this.formData.expectedReceiveWarehouseCode);
        },
        getChannel(wacode) {
            // console.log(wacode)
            let wajsonone =
                this.getFBBFilterDisabledAllWarehouse.filter((item) => {
                    return item.attach.code == wacode;
                })[0] || {};
            // console.log(wajsonone)
            if (wajsonone.attach.warehouseType !== 4) {
                this.showaccount = false;
                return;
            }
            let wareId = wajsonone.value;
            this.showaccount = true;
            HttpFindByOrgIdAndOrgWarehouseId({
                orgId: global.SYSID,
                orgWarehouseId: wareId,
            }).then(
                (res) => {
                    this.channelList = [];
                    this.channelList = res.data;
                },
                (err) => {
                    this.$$VMessage.error(err.message);
                }
            );
        },
        getPaymentType(isNoSupplier) {
            // console.log(lineid)
            let arr = this.getNewProductList.filter((item) => {
                return item.value == this.formData.lineId;
            });
            // console.log(arr)
            if (!this.formData.supplierId && this.formData.supplierId !== 0) {
                this.formData.supplierId = arr[0].attach.supplierId;
            }
            if (isNoSupplier) {
                this.getPayment(arr[0].attach.supplierId);
            }
            this.formData.paymentType = arr[0].attach.paymentType;
        },
        getPayment(supplierId) {
            if (supplierId === 0) {
                return this.getPaymentType(true);
            }
            let supplier = this.getAllSupplier.filter((item) => {
                return item.value === supplierId;
            })[0];
            this.formData.supplierId = supplier.value;
            this.formData.paymentDay =
                supplier.attach.paymentDay === null
                    ? ""
                    : supplier.attach.paymentDay;
            this.formData.paymentExplain = supplier.attach.paymentExplain;
        },
        getPrice() {
            let productIdArr = [];
            this.datalist.map((item) => {
                productIdArr.push(item.productId);
            });
            let requestData = {
                productIds: productIdArr,
                supplierId: this.formData.supplierId,
                currency: this.formData.currency,
            };
            HttpGetPrice(requestData).then(
                (res) => {
                    this.datalist.map((item) => {
                        if (res.data.length < 1) {
                            return (item.supplierProductPrice = null);
                        }
                        for (let i = 0; i < res.data.length; i++) {
                            if (item.productId === res.data[i].productId) {
                                item.supplierProductPrice = res.data[i].price;
                                return;
                            }
                        }
                    });
                },
                (err) => {
                    this.errorMessage(err.message);
                }
            );
        },
        exportExcel() {
            this.handleWebfs(
                process.env.VUE_APP_APIURL_BOSS +
                    "/api/v2/poRequisition/exportItemPointPoquisitionXlsx",
                {
                    contextId: global.SYSID,
                    id: this.formData.id,
                    supplierId: this.formData.supplierId,
                    currency: this.formData.currency,
                },
                "download"
            );
        },
        importExcel() {
            this.operate = {
                show: true,
                title: this.$t("boss.purchase.info", {
                    defaultValue: "导入",
                }),
                actionurl: "/api/v2/poRequisition/importItemPointPoquisition",
                boxtype: "importexcel",
                downexcel:
                    "/api/v2/poRequisition/downItemExcelPointPoquisition",
                data: {
                    supplierId: this.formData.supplierId
                        ? this.formData.supplierId
                        : 0,
                    id: this.activeid,
                    currency: this.formData.currency,
                },
            };
        },
        // 点击上传附件之后的操作
        aaasuccess(res) {
            this.hasImport = true;
            this.datalist = res.data.map((item) => {
                return {
                    orderId: this.formData.id,
                    id: item.poRequistionOrderItemId,
                    erpsku: item.erpsku,
                    headId: item.lineId,
                    productId: item.productId,
                    orderNo: this.formData.orderNo,
                    price: item.price,
                    supplierProductPrice: item.poPrice,
                    remark: item.remark,
                    buyquantity: item.quantity,
                    quantity: item.originQuantity,
                    availQuantity: item.availQuantity,
                    expectedNeedDate: item.expectedNeedDate,
                    valueQuantity: item.availQuantity,
                    usedQuantity:
                        Number(item.originQuantity) -
                        Number(item.availQuantity),
                };
            });
            this.cancelUpload();
        },
        cancelUpload() {
            this.operate.show = false;
        },
        async submit() {
            // 判断供应商是否填写
            // posupplier
            const valid = await this.$refs.posupplier.validate();
            if (!valid) return;

            let numberflag = false;
            this.datalist.map((item, index) => {
                if (this.hasImport) {
                    if (Number(item.buyquantity) > Number(item.availQuantity)) {
                        numberflag = true;
                    }
                } else {
                    if (item.buyquantity === 0) {
                        return;
                    }
                    if (
                        Number(item.buyquantity) >
                        Number(item.quantity) -
                            Number(item.usedQuantity) -
                            Number(item.cancelQuantity)
                    ) {
                        numberflag = true;
                    }
                }
            });
            if (numberflag) {
                this.$VMessage.error(
                    this.$t("boss.purchase.quantity_filled", {
                        defaultValue:
                            "填写的转采购数量大于实际的数量，请重新填写！",
                    })
                );
                return;
            }
            console.log(this.formData.paymentDay, "this.formData.paymentDay");
            if (
                this.formData.paymentType == "payment" ||
                this.formData.paymentType == "fk"
            ) {
                // if (
                //     this.formData.paymentDay === null ||
                //     this.formData.paymentDay === undefined ||
                //     this.formData.paymentDay === ""
                // ) {
                //     this.$VMessage.error("付款账期必须填写！");
                //     return;
                // }
                if (!this.formData.poPurchaserId) {
                    this.$VMessage.error(
                        this.$t("boss.purchase.purchaser_must", {
                            defaultValue: "采购方必须填写！",
                        })
                    );
                    return;
                }
            }

            let priceFlag = false;
            let sku = "";
            let amountall = 0;
            let arrtable = [];
            this.datalist.map((item) => {
                if (Number(item.buyquantity) > 0) {
                    amountall += Number(item.buyquantity) * Number(item.price);
                    let dataitem = {
                        poRequistionOrderId: item.orderId,
                        poRequistionOrderItemId: item.id,
                        productId: item.productId,
                        erpsku: item.erpsku,
                        price: item.supplierProductPrice,
                        quantity: item.buyquantity,
                        remark: item.remark,
                    };
                    if (
                        item.buyquantity !== 0 &&
                        (item.supplierProductPrice === null ||
                            item.supplierProductPrice === undefined ||
                            item.supplierProductPrice === "")
                    ) {
                        priceFlag = true;
                        sku = item.erpsku;
                    }
                    arrtable.push(dataitem);
                }
            });

            if (priceFlag) {
                this.$VMessage.error(
                    `${sku} ` +
                        this.$t("boss.purchase.SKU_purchase", {
                            defaultValue: "SKU采购价格未填写",
                        })
                );
                return;
            }
            if (arrtable.length < 1) {
                this.$VMessage.error(
                    this.$t("boss.purchase.cannot_be_less", {
                        defaultValue: "转采购数量不能小于0",
                    })
                );
                return;
            }
            if (this.formData.expectedReceiveWarehouseCode) {
                let warehouseitem =
                    this.getFBBFilterDisabledAllWarehouse.filter((item) => {
                        return (
                            item.attach.code ==
                            this.formData.expectedReceiveWarehouseCode
                        );
                    });

                this.formData.expectedReceiveWarehouseId =
                    warehouseitem[0].value;
                if (warehouseitem[0].attach.warehouseType !== 4) {
                    this.formData.channelFlag = "";
                }
            }

            if (this.purchaseList.length > 0) {
                this.poOrderFk.purchaseContractMeta = JSON.stringify({
                    items: this.purchaseList,
                    opAt: this.purchaseList[0].opAt,
                    organizationId: global.SYSID,
                });
            }
            if (this.exportList.length > 0) {
                this.poOrderFk.exportContractMeta = JSON.stringify({
                    items: this.exportList,
                    opAt: this.exportList[0].opAt,
                    organizationId: global.SYSID,
                });
            }
            if (this.$refs.fkform) {
                const valid2 = await this.$refs.fkform.validate();
                if (!valid2) return;
                if (
                    this.purchaseList.length === 0 ||
                    this.exportList.length === 0
                ) {
                    return this.$VMessage.error(
                        this.$t("boss.purchase.purchase_and_export", {
                            defaultValue: "请上传采购合同和外销合同",
                        })
                    );
                }
                this.formData.poOrderFk = this.poOrderFk;
            }
            this.formData.poOrderItem = this.datalist2;

            this.loading = true;
            HttpSavePoPurchase({
                id: this.activeid,
                ...this.formData,
                paymentTermId: this.paymentItem.id,
                amount: amountall,
                poOrderItem: arrtable,
                currency: this.formData.currency,
            }).then(
                (res) => {
                    this.loading = false;
                    this.$VMessage.success(res.message);
                    // console.log(res)

                    // this.$router.push({
                    //     name: "purchaseOrderUpdate",
                    //     params: { type: "edit" },
                    //     query: { id: res.data.id }
                    // });

                    var url = this.$router.resolve({
                        name: "purchaseOrderUpdate",
                        params: { type: "edit" },
                        query: { id: res.data.id },
                    });
                    window.open(url.href, "_blank");
                },
                (err) => {
                    this.loading = false;
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
        cancel() {
            this.$emit("on-close");
        },
    },
};
</script>
